import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setInstitution } from 'store/entities/submissions';

import { Control, Label, Select } from 'components/UIComponents/Form';

const InstitutionFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { institution, submissionsListLoading } = useSelector(
    state => state.submissions
  );
  const { institutions } = useSelector(state => state.institutions);

  const institutionOptions = useMemo(
    () =>
      institutions.map(inst => ({
        value: inst,
        label: inst.name,
      })),
    [institutions]
  );

  return (
    <Control>
      <Label htmlFor="institutionSelect">
        {t('datagate.external.submissions.filter.institution.label')}
      </Label>
      <Select
        isClearable={true}
        isDisabled={submissionsListLoading}
        id="institutionSelect"
        placeholder={t(
          'datagate.external.submissions.filter.institution.placeholder'
        )}
        options={institutionOptions}
        value={institution}
        onChange={value => dispatch(setInstitution(value))}
        ariaLabel="Institution select"
      />
    </Control>
  );
};

export default InstitutionFilter;
